'use strict';
import React, { PureComponent } from 'react';
import GrupoRadioButton from '../../../Common/GrupoRadioButton';
import BuscadorCuentasContables from '../../../Common/BuscadorCuentasContables';

class ModalCopiarRenglonContable extends PureComponent {
    constructor(props) {
        super(props);

        this.onKeyPress = this.onKeyPress.bind(this);
        this.cambiarValorInput = this.cambiarValorInput.bind(this);
        this.validarYGuardar = this.validarYGuardar.bind(this);
    }

    componentDidMount() {
        //Cuando el modal se active, al ser de un largo extenso, se posiciona al inicio de la ventana para que pueda visualizarse el modal desde el inicio
        //y no desde el lugar del botón donde se activó
        window.scrollTo(0, 0);
    }

    onKeyPress(event) {
        let regExp = /^([1-9]|[1-9][0-9]+)$/ig;

        if (!regExp.test(event.key)) {
            event.preventDefault();
        }
    }

    cambiarValorInput(event, seccionInput, nombreInput, maximoRenglon) {
        let valorInput = event.target.value;

        if(parseInt(valorInput) > maximoRenglon) {
            event.preventDefault();
        } else {
            this.props.limpiarMensajeError("modalCopiarRenglonContable");
            this.props.cambiarValorInput(seccionInput, nombreInput, valorInput);
        }
    }

    validarYGuardar() {
        this.props.validarGuardarCopiaRenglon();
    }

    render() {
        const {
            cuentasContablesFiltradas,
            cuentaSeleccionada,
            inputActivo,
            inputsCopiarRenglonContable,
            mostrarSpinnerModales,
            rbModalCopiarRenglonContable,
            ultimoNumeroRenglon
        } = this.props

        //ACTIONS
        const {
            buscarCuentasContables,
            cambiarInputActivo,
            errorValidacion,
            guardarValorInput,
            mostrarOcultarModalCopiarRenglonContable,
            seleccionarRadioButtonABMModelos
        } = this.props;

        let rbUbicacionRenglon = rbModalCopiarRenglonContable.rbUbicacionRenglon;
        let rbTipoOperacion = rbModalCopiarRenglonContable.rbTipoOperacion;
        let rbSignoImporte = rbModalCopiarRenglonContable.rbSignoImporte;
        let maximoRenglon = (parseInt(ultimoNumeroRenglon) + 1);

        return (
            <div className="modalContainer ABMMModalContainerLarge">                
                <div className="ABMModelosModalContainer">
                    {mostrarSpinnerModales ?
                        <div id="loading" className="loading" />
                    :
                        null
                    }

                    <div className="ABMModelosModalContainer__header">
                        <div className="ABMModelosModalContainer__contenedorTituloBoton">
                            <div className="ABMModelosModalContainer__titulo">Copiar renglón seleccionado</div>
                            <div className="ABMModelosModalContainer__botonCerrar" onClick={() => mostrarOcultarModalCopiarRenglonContable("modalCopiarRenglonContable", false)}></div>
                        </div>
                        <div className="ABMModelosModalContainer__modalAltaEdicionRenglonContable__lineaDivisoria ABMModelosModalContainer__modalAltaEdicionRenglonContable__lineaDivisoriaHeader"></div>
                    </div>

                    <div className="ABMModelosModalContainer__body ABMModelosModalContainer__copiarRenglonBody">
                        <div>
                            <div className="seccionDatosGenerales__tituloSecundario">Ubicar la copia del renglón seleccionado</div>

                            <div>
                                <div className="seccionDatosGenerales__contenedorMarca ABMModelosModalContainer__ubicacionCopia">
                                    <GrupoRadioButton 
                                        activo={rbUbicacionRenglon == 0}
                                        classLabel={""}
                                        estaHabilitado={true}
                                        label={"Debajo del renglón seleccionado"}
                                        nombre={"rbUbicacionRenglon"}
                                        onClick={seleccionarRadioButtonABMModelos}
                                        seccion={"modalCopiarRenglonContable"}
                                        valor={0}
                                    />
                                </div>

                                <div className="seccionDatosGenerales__contenedorMarca ABMModelosModalContainer__ubicacionCopia">
                                    <GrupoRadioButton 
                                        activo={rbUbicacionRenglon == 1}
                                        classLabel={""}
                                        estaHabilitado={true}
                                        label={"Como último renglón del modelo"}
                                        nombre={"rbUbicacionRenglon"}
                                        onClick={seleccionarRadioButtonABMModelos}
                                        seccion={"modalCopiarRenglonContable"}
                                        valor={1}
                                    />
                                </div>

                                <div className="seccionDatosGenerales__contenedorMarca ABMModelosModalContainer__ubicacionCopia">
                                    <div className="ABMModelosModalContainer__ubicacionCopia__contenedorPosicion">
                                        <GrupoRadioButton 
                                            activo={rbUbicacionRenglon == 2}
                                            classLabel={""}
                                            estaHabilitado={true}
                                            label={"En la posición N:"}
                                            nombre={"rbUbicacionRenglon"}
                                            onClick={seleccionarRadioButtonABMModelos}
                                            seccion={"modalCopiarRenglonContable"}
                                            valor={2}
                                        />
                                    </div>

                                    <div className="ABMModelosModalContainer__ubicacionCopia__contenedorPosicionInput">
                                        <input 
                                            className="seccionDatosGenerales__inputSelect ABMModelosModalContainer__ubicacionCopiaInput"
                                            disabled={!(rbUbicacionRenglon == 2)}
                                            id="numeroPosicion"
                                            name="numeroPosicion"
                                            onChange={(event) => rbUbicacionRenglon == 2 ? this.cambiarValorInput(event, "modalCopiarRenglonContable", "inputNumeroRenglon", maximoRenglon) : null}
                                            onKeyPress={(event) => rbUbicacionRenglon == 2 ? this.onKeyPress(event) : null}
                                            type="text"
                                            value={inputsCopiarRenglonContable.inputNumeroRenglon}
                                        />
                                    </div>

                                    <div className="ABMModelos--floatLeft">
                                        <label className="ABMModelosModalContainer__ubicacionCopia__labelMaximoRenglon">{"El valor máximo para el número de renglón es " + maximoRenglon.toString()}</label>
                                    </div>
                                </div>

                                {errorValidacion.modalCopiarRenglonContable.inputNumeroRenglon ? 
                                    <div>
                                        <label className="error">{errorValidacion.modalCopiarRenglonContable.inputNumeroRenglon}</label>
                                    </div>
                                :
                                    null
                                }
                            </div>
                        </div>

                        <div className="ABMModelosModalContainer__ajustesDatosNuevoRenglon">
                            <div className="ABMModelosModalContainer__subtitulo">Ajustes de datos del nuevo renglón</div>

                            <div className="ABMModelosModalContainer__modalAltaEdicionRenglonContable__lineaDivisoria"></div>

                            <div>
                                <div className="ABMModelosModalContainer__contenedorGrupoRadioButtons">
                                    <div className="seccionDatosGenerales__tituloSecundario">Tipo operación</div>

                                    <div>
                                        <div className="ABMModelosModalContainer__contenedorRadioButtonIzquierda">
                                            <GrupoRadioButton 
                                                activo={rbTipoOperacion == "D"}
                                                classLabel={""}
                                                estaHabilitado={true}
                                                label={"Débito"}
                                                nombre={"rbTipoOperacion"}
                                                onClick={seleccionarRadioButtonABMModelos}
                                                seccion={"modalCopiarRenglonContable"}
                                                valor={"D"}
                                            />
                                        </div>

                                        <div className="ABMModelosModalContainer__contenedorRadioButtonDerecha">
                                            <GrupoRadioButton 
                                                activo={rbTipoOperacion == "C"}
                                                classLabel={""}
                                                estaHabilitado={true}
                                                label={"Crédito"}
                                                nombre={"rbTipoOperacion"}
                                                onClick={seleccionarRadioButtonABMModelos}
                                                seccion={"modalCopiarRenglonContable"}
                                                valor={"C"}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="ABMModelosModalContainer__contenedorBuscadorCuentasContables">
                                    <div className="seccionDatosGenerales__tituloSecundario">Cuenta contable</div>
                                    
                                    <div className="ABMModelos--overflowHidden">
                                        <BuscadorCuentasContables
                                            buscarCuentasContables={buscarCuentasContables}
                                            cambiarInputActivo={cambiarInputActivo}
                                            cuentasContables={cuentasContablesFiltradas}
                                            estaHabilitado={true}
                                            estiloPlaceholder={""}
                                            guardarValorInput={guardarValorInput}
                                            inputActivo={inputActivo}
                                            inputClassValorSeleccionado={Boolean(cuentaSeleccionada) ? " ABMModelos__buscadorCuentasContables--valorSeleccionado" : ""}
                                            nombreInput={"inputCuentaContable"}
                                            seccionInput={"modalCopiarRenglonContable"}
                                            valorInput={inputsCopiarRenglonContable.inputCuentaContable}
                                        />
                                    </div>
                                       {errorValidacion.modalCopiarRenglonContable.inputCuentaContable ? 
                                    <div>
                                        <label className="error">{errorValidacion.modalCopiarRenglonContable.inputCuentaContable}</label>
                                    </div>
                                :
                                    null
                                }
                                </div>

                                <div className="ABMModelosModalContainer__contenedorGrupoRadioButtons">
                                {rbModalCopiarRenglonContable.rbSignoImporte !== "A" && (
                                 <div>
                                        <div className="seccionDatosGenerales__tituloSecundario">Signo del campo de importe</div><div>
                                        {rbModalCopiarRenglonContable.mostrarSignoAmbos ?
                                            <div className="ABMModelosModalContainer__contenedorRadioButtonIzquierda">
                                                <GrupoRadioButton 
                                                    activo={rbSignoImporte == "A"}
                                                    classLabel={""}
                                                    estaHabilitado={true}
                                                    label={"Ambos"}
                                                    nombre={"rbSignoImporte"}
                                                    onClick={seleccionarRadioButtonABMModelos}
                                                    seccion={"modalCopiarRenglonContable"}
                                                    valor={"A"}
                                                />
                                            </div>
                                        :
                                            null
                                        }

                                        <div className={rbModalCopiarRenglonContable.mostrarSignoAmbos ? "ABMModelosModalContainer__contenedorRadioButtonDerecha" : "ABMModelosModalContainer__contenedorRadioButtonIzquierda"}>
                                            <GrupoRadioButton 
                                                activo={rbSignoImporte == "P"}
                                                classLabel={""}
                                                estaHabilitado={true}
                                                label={"Positivo"}
                                                nombre={"rbSignoImporte"}
                                                onClick={seleccionarRadioButtonABMModelos}
                                                seccion={"modalCopiarRenglonContable"}
                                                valor={"P"}
                                            />
                                        </div>

                                        <div className="ABMModelosModalContainer__contenedorRadioButtonDerecha">
                                            <GrupoRadioButton 
                                                activo={rbSignoImporte == "N"}
                                                classLabel={""}
                                                estaHabilitado={true}
                                                label={"Negativo"}
                                                nombre={"rbSignoImporte"}
                                                onClick={seleccionarRadioButtonABMModelos}
                                                seccion={"modalCopiarRenglonContable"}
                                                valor={"N"}
                                            />
                                        </div>
                                    </div>
                                </div>
                               )}
                                </div>
                              
                            </div>
                        </div>
                    </div>

                    <div className="ABMModelosModalContainer__footer">
                        <div>
                            <button className="ABMModelosModalContainer__botonAceptar" onClick={this.validarYGuardar}>
                                Aceptar
                            </button>
                        </div>

                        <div>
                            <button className="ABMModelosModalContainer__botonCancelar" onClick={() => mostrarOcultarModalCopiarRenglonContable("modalCopiarRenglonContable", false)}>
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalCopiarRenglonContable;